import { EFormQuestionType, isGradingAnswerComplete, type TSubmitFormAnswer } from '@onesource/schemas';
import type { TFormQuestion, TReviewAnswer } from '@onesource/services';

/** Stored answers → the per-question map the question components take. */
export const toAnswerMap = (answers: TReviewAnswer[] | undefined): Record<string, TSubmitFormAnswer> =>
  Object.fromEntries(
    (answers ?? []).map(a => [
      a.questionId,
      {
        questionId: a.questionId,
        selectedOptionIds: a.selectedOptionIds ?? [],
        orderingSequence: a.orderingSequence ?? [],
        textAnswer: a.textAnswer ?? undefined,
        fileUrls: a.fileUrls ?? [],
        value: a.value ?? undefined,
      },
    ]),
  );

/** Whether an answer carries anything worth saving (same rule as the form page). */
export const hasAnswerValue = (answer: TSubmitFormAnswer | undefined): boolean =>
  !!answer &&
  ((answer.selectedOptionIds?.length || 0) > 0 ||
    (answer.orderingSequence?.length || 0) > 0 ||
    (answer.textAnswer?.trim().length || 0) > 0 ||
    (answer.fileUrls?.length || 0) > 0 ||
    Object.keys(answer.value ?? {}).length > 0);

/** Whether a required question counts as answered — a grading question needs every row. */
export const isRequiredAnswered = (question: TFormQuestion, answer: TSubmitFormAnswer | undefined): boolean =>
  question.questionType === EFormQuestionType.MULTIPLE_GRADING
    ? isGradingAnswerComplete(question.metadata, answer?.value)
    : hasAnswerValue(answer);

export const emptyAnswer = (questionId: string): TSubmitFormAnswer => ({ questionId });
